<template>
  <div class="chart">
    <div ref="mapChart" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "mapChartView",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "350px",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    mapData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "canvas",
    },
    regionName: {
      type: String,
      default: "",
    },
    isRegion: {
      type: Boolean,
      default: false,
    },
    allMap: {
      type: Object,
      default: null,
    },
    formatter: {
      type: Function,
      defalult: null,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
    mapData: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  mounted() {
    echarts.registerMap("hongsibao", this.allMap);

    this.initChart();

    if (this.autoResize) {
      window.addEventListener("resize", this.resizeHandler);
    }
  },
  unmounted() {
    console.log("map chart unmounted");
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener("resize", this.resizeHandler);
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeHandler() {
      this.chart.resize();
    },
    initChart() {
      const _this = this;
      this.chart = echarts.init(this.$refs.mapChart, "", {
        renderer: this.type,
      });
      this.initChartOption();
      this.chart.on("click", "series", function(e) {
        if (_this.isRegion) {
          console.log(e, "eee");
          _this.$router.push({
            name: "Video",
            query: {
              regionName: e.data.value[2],
              name: e.data.name,
              code: e.data.regionCode,
            },
          });
        } else {
          console.log(e.data, "hahahahahahahahahah");
          _this.$router.push({
            name: "RegionScreen",
            query: {
              name: e.data.name,
              code: e.data.regionCode || e.data.code,
            },
          });
        }
      });
      // if (this.farmPoints) {
      //   this.chart.on("click", "series", function (e) {
      //     console.log("click", e);
      //     _this.$router.push({
      //       name: "Video",
      //       query: {
      //         name: e.data.name
      //       }
      //     });
      //   });
      // } else {
      //   this.chart.on("click", "series", function (e) {
      //     console.log("click", e);
      //     _this.$router.push({
      //       name: "RegionScreen",
      //       query: {
      //         name: e.data.name,
      //         code: e.data.code
      //       }
      //     });
      //   });
      // }

      // this.chart.on('click', this.handleClick)
    },
    initChartOption() {
      const _this = this;
      this.chart.setOption({
        geo: {
          show: true,
          map: "hongsibao",
          roam: true,
          aspectScale: 0.75, //长宽比
          zoom: 1.1,
          emphasis: {
            label: {
              show: false,
            },
          },
          select: {
            label: {
              show: false,
            },
            itemStyle: {
              areaColor: "#2B91B7",
              borderColor: "#3fdaff",
              borderWidth: "3",
            },
          },
          label: {
            show: false,
          },
          itemStyle: {
            areaColor: {
              image: require("@/assets/images/mapBg.png"),
              repeat: "repeat",
            },
            borderColor: "#3fdaff",
            borderWidth: 2,
            shadowColor: "rgba(21, 75, 142, 0.8)",
            shadowOffsetX: 0,
            shadowOffsetY: 25,
            // shadowColor: 'rgba(63, 218, 255, 0.5)',
            shadowBlur: 15,
            emphasis: {
              show: true,
              areaColor: "#2B91B7",
            },
          },
        },
        series: [
          {
            type: "map",
            map: "hongsibao",
            geoIndex: 0,
            zoom: 1.1,
            roam: true,
            label: {
              show: true,
              color: "#fff",
            },
            itemStyle: {
              borderColor: "#2ab8ff",
              areaColor: "#12235c",
              emphasis: {
                show: true,
                areaColor: "#2AB8FF",
              },
            },
            data: _this.mapData,
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            itemStyle: {
              color: "#f00",
            },
            symbol:
              "image://" +
              require("@/assets/images/screen/screen_map_poins.png"),
            symbolSize: 36,
            symbolOffset: [0, -6],
            z: 9999,
            data: _this.data,
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            label: {
              normal: {
                show: true,
                offset: [10, 0],
                formatter: function(params) {
                  return params.name;
                },
                color: "#FFF",
                fontSize: 20,
                fontWeight: "bold",
              },
              emphasis: {
                show: true,
              },
            },
            itemStyle: {
              // color: '#00FFF6',
            },
            symbol:
              "image://" +
              require("@/assets/images/screen/screen_map_title.png"),
            symbolSize: [120, 40],
            symbolOffset: [0, -42],
            z: 999,
            data: _this.data,
          },
        ],
      });

      // 总图显示基础信息
      if (!this.isRegion) {
        this.chart.setOption({
          tooltip: {
            trigger: "item",
            backgroundColor: "#022843",
            borderColor: "#0362a0",
            textStyle: {
              color: "#fff",
            },
            formatter: this.formatter
              ? this.formatter
              : function(params) {
                  if (params.componentSubType === "map") {
                    let res =
                      "" +
                      params.name +
                      "<br>" +
                      "牛存栏量：" +
                      (params.data.cattleExistCount != 0
                        ? `${params.data.cattleExistCount} 只`
                        : "--") +
                      "<br>" +
                      "羊存栏量：" +
                      (params.data.sheepExistCount != 0
                        ? `${params.data.sheepExistCount} 只`
                        : "--") +
                      "<br>" +
                      "存栏蛋鸡数量：" +
                      (params.data.poultryExistCount != 0
                        ? `${params.data.poultryExistCount} 只`
                        : "--") +
                      "<br>" +
                      "存栏生猪数量：" +
                      (params.data.otherExistCount != 0
                        ? `${params.data.otherExistCount} 只`
                        : "--");
                    +"<br>";
                    return res;
                  }
                },
          },
        });
      }
    },
    setOptions() {
      this.clearChart();
      this.resizeHandler();
      if (this.chart) {
        this.initChartOption();
      }
    },
    refresh() {
      this.initChartOption();
    },
    clearChart() {
      this.chart && this.chart.clear();
    },
  },
};
</script>
